export default function() {
    return {
        register: {}
    }
}


